import { Template } from "./template.js";


const Left_menu = {
	data() {
		return {
			perPage: globalConstants.linesPerPageLeftMenu,
			currentPage: 1,
			filter: null,
			fields: [{
				key: 'wire',
				label: '',
				sortable: true
			}, {
				key: 'serial',
				label: this.$t('messages.sN'),
				sortable: true,
			},
			{
				key: 'battery',
				label: '🔋,%',
				sortable: true
			}, ],

		}
	},
	computed: {
		menuRows() {
			return this.modems.length
		},
		rowClass() {}
	},
	updated() {
		this.fields[1].label = this.$t('messages.sN');
	},
	props: {
		modems: Array
	},
	methods: {
		modemListClick(record, index) {
			this.$emit("line-click", record);
		},
		wire(item) {
			let icons = '';
			icons += (item.too_old ? '⏰' : '');
			return icons;
		},
		shortSerial(item) {
			if (item.serial)
				return item.serial.substring(0, 35) + (item.serial.substring(35, 36) ? '...' : '');
		}

	},
	template: Template
}

export { Left_menu }


// WEBPACK FOOTER //
// ./src/app/js/components/page5_notifications/left_menu/component.js